<template>
    <component :is="layout">
        <router-view />
    </component>
</template>

<script>
import AppLayoutDefault from './layouts/AppLayoutDefault';
import AppLayoutLogin from './layouts/AppLayoutLogin';
import AppLayoutMain from './layouts/AppLayoutMain';

export default {
    components: {
        AppLayoutMain,
        AppLayoutLogin,
        AppLayoutDefault,
    },
    computed: {
        layout() {
            return this.$route.meta.layout || AppLayoutDefault;
        },
    },
};
</script>

<style lang="scss">
@import './App.scss';

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
body {
    background-color: var(--clarity-snow-grey);
}
</style>
